export default __webpack_public_path__ + "5a80e955e597c07231bbb227f46aaa25.jpg";